<template>
    <div class="pdp-notice-alert" :class="alertType" :id="id + '-' + itemIndex" :ref="id + '-' + itemIndex">
        <i :class="alertIcon"/>
        <p class='message' v-html="alertMessage"/>
    </div>
</template>

<script>
import {storePdp} from "@/store/product-page";

export default {
    storePdp,
    name: "NotificationAlert",
    components: {},
    props: {
        id: {
            type: String,
            default: 'pdpNotice',
        },
        itemIndex: { // for multiple widgets
            type: Number,
            default: 0,
        },
        noticePropData: { // overrides store data, good for permanent notices, ex: unavailable products
            type: Object,
            default: null // {type: 'info', message: 'oh no!', icon: 'prz-info' }
        }
    },

    computed: {
        notificationAlert() {
            if (this.noticePropData) {
                return this.noticePropData;
            }

            return storePdp.getters['pdpDesktop/addToCartDesktop/toastNotification'];
        },
        alertType() { // info, warning, success & error
            if (!this.notificationAlert) {
                return 'info';
            }

            if (this.notificationAlert.type) {
                return this.notificationAlert.type;
            }

            return this.notificationAlert.success ? 'success' : 'error';

        },
        alertMessage() {
            if (!this.notificationAlert) {
                return '';
            }
            return this.notificationAlert.message;
        },
        alertIcon() {
            if (!this.notificationAlert) {
                return 'prz-info'
            }

            if (this.notificationAlert.icon) {
                return this.notificationAlert.icon;
            }

            return this.notificationAlert.success ? 'prz-success-fill' : 'prz-error';

        }
    },
    methods: {},
    watch: {},

    mounted() {
    }
};
</script>

<style lang="scss">
@import "../styles/notificationAlert";
</style>
